import React from 'react';
// Import Component Styles
import { ProgressWrapper, ProgressBar } from './styles';

export default function({ usedValue }) {
  return <ProgressWrapper>
    <ProgressBar usedValue={usedValue} />
  </ProgressWrapper>;
};
